import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Api_Success_Res } from "./api.types";

export type T_CardActivity = {
  _id: string;
  type: "card_moved" | "email_sent";
  status: "sent" | "failed" | "pending_manual" | null;
  templateName: string | null;
  templateId: string | null;
  unresolvedVariables: string[];
  resolvedVariables: string[];
  to: string[] | null;
  failReason: string | null;
  board_id: string;
  card_id: string;
  applicationId: string | null;
  createdAt: string;
  updatedAt: string;
};

export const cardActivityService = {
  useGetCardActivity: (params: { activityId: string } | undefined) => {
    return useQuery({
      queryKey: ["card-activity", params?.activityId],
      enabled: Boolean(params?.activityId),
      queryFn: async () => {
        const res = await api.get(`/board/activity/${params!.activityId}`);
        return res.data as T_Api_Success_Res<T_CardActivity>;
      },
    });
  },
};
